import { Link } from "react-router-dom";

export default function Cta({
  title = "Klaar om te Besparen?",
  text = "Begin nu met het vinden van de beste ticket deals!",
  buttons = [
    { to: "/concerttickets", label: "Bekijk Concerttickets" },
    { to: "/festivaltickets", label: "Bekijk Festivaltickets" },
  ],
}) {
  return (
    <section data-testid="cta-section" className="bg-[#2C3E50]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
          {title}
        </h2>
        <p className="text-lg text-slate-300 mb-8 max-w-2xl mx-auto">{text}</p>
        <div className="flex flex-wrap justify-center gap-4">
          {buttons.map((b, i) => (
            <Link
              key={b.to + i}
              to={b.to}
              data-testid={`cta-btn-${b.to.replace("/", "")}`}
              className="bg-[#FF6B35] hover:bg-[#E55A2A] text-white font-semibold rounded-full px-8 py-4 transition-all hover:-translate-y-1 shadow-md"
            >
              {b.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
